<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import maintenanceAPI from "@/services/standards/inventory_mi/maintenanceAPI";
import inventory_miAPI from "@/services/standards/inventory_mi/inventory_miAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification";
import CheckModal from "@/components/CheckModal";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "4.2.5 Mantenimiento periódico de instalaciones, equipos, máquinas y herramientas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {

    return {
      title: "4.2.5 Mantenimiento periódico de instalaciones, equipos, máquinas y herramientas",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "4.2.5 Mantenimiento periódico de instalaciones, equipos, máquinas y herramientas",
          active: true,
        },
      ],
      lista: [],
      inventario: null,
      usersList: [],
      file: null,
      loading: true,
      submitted: false,
      item: null,
      itemData: null,
      maintenance: {
        options: null,
        start_date: null,
        end_date: null,
        observations: null,
        employee_id: 1,
        inventory_mis_id: this.$route.params.id,
        file: "datos",
      },
      inventory: 'Sin equipo',
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res.employee
              this.loading = false
            })
        })
        .catch((error) => {
          console.log(error);
        });

    },

    getItemData() {
      ItemAPI.getItems(49)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 49)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    getMaintenance() {
      maintenanceAPI
        .getmaintenance(this.$route.params.id)
        .then((response) => {
          this.maintenance = {
            start_date: response.start_date,
            options: response.options,
            end_date: response.end_date,
            observations: response.observations,
            employee_id: response.employee_id,
            inventory_mis_id: response.inventory_mis_id,
            companies_id: response.companies_id,
            file: response.file,
          };
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },


    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.maintenance.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/4.2.5/${this.maintenance.inventory_mis_id}/mantenimiento/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/4.2.5/${this.maintenance.inventory_mis_id}/mantenimiento/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.maintenance.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getEquip() {
      inventory_miAPI.getinventory_mi(this.$route.params.id)
        .then((response) => {
          this.inventory = response.data.name
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async save() {
      this.submitted = true
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        maintenanceAPI.updatemaintenance(this.$route.params.id, {
          options: this.maintenance.options,
          start_date: this.maintenance.start_date,
          end_date: this.maintenance.end_date,
          employee_id: this.maintenance.employee_id,
          inventory_mis_id: this.maintenance.inventory_mis_id,
          file: this.maintenance.file,
          observations: this.maintenance.observations
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 49,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha actualizado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  this.$router.go(-1);
                }, 2000)
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido actualizar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload()
        }, 2000)
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getItems()
    this.getEquip();
    this.getMaintenance()
    this.getItemData();
    this.getUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
          <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <h4 class="header-title col-6">Nombre: {{ this.inventory }} </h4>
                </div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                </div>
              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Asignado a">
                    <select required class="form-control" disabled v-model="maintenance.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group label="Tipo de mantenimiento" label-for="tipo" inline class="col-sm-6 pb-2">
                    <label class="mr-2">
                      Mantenimiento preventivo
                    </label>
                    <input type="radio" id="tipo" style="color: #666" value="Mantenimiento preventivo"
                      v-model="maintenance.options" class="mb-2 mr-sm-2 mb-sm-0" label="tipo" />
                    <label class="mr-2 pl-sm-2 pl-md-0">
                      Mantenimiento correctivo
                    </label>
                    <input type="radio" value="Mantenimiento correctivo" id="tipo" v-model="maintenance.options"
                      class="mb-2 mr-sm-2 mb-sm-0" label="tipo" />
                  </b-form-group>

                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6" label="Fecha programada inicio mantenimiento" label-for="input-sm">
                    <b-form-input v-model="maintenance.start_date" type="date" id="date1" placeholder="Fecha inicio">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-6" label="Fecha programada fin mantenimiento" label-for="hora">
                    <b-form-input v-model="maintenance.end_date" type="date" id="date2"
                      placeholder="Fecha fin"></b-form-input>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-12" label="Observaciones" label-for="input-sm">
                    <b-form-textarea v-model="maintenance.observations" id="textarea" rows="4"></b-form-textarea>
                  </b-form-group>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file required type="file" id="file" ref="file" name="file" browse-text="Buscar"
                      :placeholder="maintenance.file ? getFile(maintenance.file) : `Selecciona un archivo...`"
                      v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>